var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBtnRgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.389648 0.572998H10.5752C13.3366 0.572998 15.5752 2.81157 15.5752 5.573V13.3288",
    stroke: "#FF7038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBtnRgt);
export default __webpack_public_path__ + "static/media/hero-btn-rgt.8d1ac93ea2bd5dc4d66ed1063a9da59c.svg";
export { ForwardRef as ReactComponent };